import type { SchemaBuilderFieldFlagsProps } from "./schema-builder-field-flags.type";

import { EyeFilled, EyeInvisibleFilled, FilterFilled } from "@ant-design/icons";
import { Flex } from "antd";

import { getSchemaFieldFlags } from "./schema-builder-field-flags.helper";

export const SchemaBuilderFieldFlags = ({
  schema,
}: SchemaBuilderFieldFlagsProps) => {
  const { hasVisibleCondition, hasValuesCondition } =
    getSchemaFieldFlags(schema);

  if (!hasVisibleCondition && !hasValuesCondition) return null;

  return (
    <Flex gap="small">
      {hasVisibleCondition && (
        <span>
          <EyeFilled />/<EyeInvisibleFilled />
        </span>
      )}
      {hasValuesCondition && <FilterFilled />}
    </Flex>
  );
};
